 ///home/clement/compta-app/client/src/components/Facturation/Vente/CreerFactureVente.js
 
import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createFactureVente } from '../../../api/factureVenteApi';


const CreerFactureVente = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    clientId: '',
    date: new Date().toISOString().split('T')[0],
    montantHT: '',
    tva: 20,
    montantTTC: '',
    statut: 'brouillon',
    description: '',
    produits: [],
  });
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Chargement des clients depuis l'API
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch('/api/clients');
        const data = await response.json();
        setClients(data);
      } catch (err) {
        console.error("Erreur lors du chargement des clients:", err);
      }
    };
    fetchClients();
  }, []);

  // Calcul automatique du montant TTC
  useEffect(() => {
    if (formData.montantHT && formData.tva) {
      const ttc = parseFloat(formData.montantHT) * (1 + parseFloat(formData.tva) / 100);
      setFormData(f => ({ ...f, montantTTC: ttc.toFixed(2) })); // Utilisation de la fonction de mise à jour
    }
  }, [formData.montantHT, formData.tva]); // Dépendances précises

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createFactureVente(formData);
      navigate('/factures-vente');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Créer une facture de vente
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Client</InputLabel>
          <Select
            name="clientId"
            value={formData.clientId}
            onChange={handleChange}
            required
          >
            {clients.map((client) => (
              <MenuItem key={client.id} value={client.id}>
                {client.nom}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Date"
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Montant HT (€)"
          type="number"
          name="montantHT"
          value={formData.montantHT}
          onChange={handleChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="TVA (%)"
          type="number"
          name="tva"
          value={formData.tva}
          onChange={handleChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Montant TTC (€)"
          type="number"
          name="montantTTC"
          value={formData.montantTTC}
          InputProps={{ readOnly: true }}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          multiline
          rows={4}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Statut</InputLabel>
          <Select
            name="statut"
            value={formData.statut}
            onChange={handleChange}
            required
          >
            <MenuItem value="brouillon">Brouillon</MenuItem>
            <MenuItem value="envoyée">Envoyée</MenuItem>
            <MenuItem value="payée">Payée</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreerFactureVente;
